


































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import Modal from '@/components/common/Modal.vue';
import { ModalOptions } from '@/models/modal.interface';
import { WorkflowStatus } from '@/models/util.interface';
import { User } from '@/models/user.interface';

@Component({ components: { Modal } })
export default class UserForm extends Vue {
  @Action('addUserAction') public addUserAction!: (payload: User) => void;
  @Action('updateUserAction') public updateUserAction!: (payload: User) => void;
  @Getter public userWorkflowStatus!: WorkflowStatus;
  @Getter public emailExistsError!: string;
  @Prop() private user!: User;
  private userForm!: User;

  constructor() {
    super();
    this.initUser();
  }

  public async onSubmit(): Promise<void> {
    const isValid = await this.$validator.validate();
    if (isValid) {
      !this.userForm._id ? this.addUserAction(this.userForm) : this.updateUserAction(this.userForm);
    }
  }

  private initUser(): void {
    this.userForm = this.user
      ? { ...this.user }
      : {
          email: '',
          password: '',
          confirmPassword: '',
          role: 1,
        };
  }

  @Watch('userWorkflowStatus')
  private onUserSaved(value: WorkflowStatus, oldValue: WorkflowStatus): void {
    if (value.add.success || value.update.success) {
      this.$notify({text: `Utilisateur ${value.add.success ? 'créé' : 'modifié'} avec succès`, type: 'success'});
      this.$router.push('/user/list');
    }
  }
}
